"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var core_1 = require("@material-ui/core");
var IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
var CheckCircleIcon_1 = __importDefault(require("./widgets/CheckCircleIcon"));
var CloseIcon_1 = __importDefault(require("./widgets/CloseIcon"));
var actions_1 = __importDefault(require("./pages/RootPage/actions"));
var types_1 = require("../util/types");
var useStyles = core_1.makeStyles(function (theme) {
    var _a;
    return core_1.createStyles({
        root: {
            alignItems: 'stretch',
        },
        error: {
            backgroundColor: '#FFEDED',
            color: theme.palette.text.primary,
        },
        info: {
            backgroundColor: theme.palette.primary.dark,
        },
        success: {
            backgroundColor: '#EAF9E7',
            color: theme.palette.text.primary,
        },
        before: {
            '&::before': {
                backgroundColor: theme.palette.primary.dark,
                width: '4px',
                content: '""',
                marginRight: theme.spacing(2.25),
            },
        },
        content: (_a = {
                padding: 0,
                borderRadius: '3px',
                boxShadow: '0px 0px 7px rgba(56, 74, 81, 0.15)',
                fontSize: '0.875rem',
                fontWeight: 400,
                width: 'calc(100vw - 20px)',
                display: 'flex',
                alignItems: 'stretch',
                flexWrap: 'nowrap',
                minHeight: '56px'
            },
            _a[theme.breakpoints.up('sm')] = {
                width: '600px',
            },
            _a),
        closeButton: {
            marginRight: theme.spacing(2.5),
        },
        message: {
            display: 'flex',
            alignItems: 'center',
        },
        iconWrapper: {
            width: '16px',
            height: '16px',
        },
        checkCircleIcon: {
            marginRight: theme.spacing(1),
        },
    });
});
var MessageSnackbar = function () {
    var theme = core_1.useTheme();
    var classes = useStyles();
    var message = react_redux_1.useSelector(function (state) { return state.root.snackbarMessage.message; });
    var variant = react_redux_1.useSelector(function (state) { return state.root.snackbarMessage.variant; });
    var dispatch = react_redux_1.useDispatch();
    var closeSnackbar = function (_, reason) {
        if (reason !== 'clickaway') {
            dispatch(actions_1.default.closeSnackbar());
        }
    };
    var isMobileView = core_1.useMediaQuery(theme.breakpoints.down('xs'));
    var colorClass = '';
    switch (variant) {
        case types_1.snackbarVariants.ERROR:
            colorClass = classes.error;
            break;
        case types_1.snackbarVariants.INFO:
            colorClass = classes.info;
            break;
        case types_1.snackbarVariants.SUCCESS:
            colorClass = classes.success;
            break;
        default:
            break;
    }
    return (react_1.default.createElement(core_1.Snackbar, { open: !!message, autoHideDuration: 5000, className: classes.root, onClose: closeSnackbar, anchorOrigin: {
            horizontal: 'center',
            vertical: isMobileView ? 'bottom' : 'top',
        } },
        react_1.default.createElement(core_1.SnackbarContent, { message: react_1.default.createElement(react_1.default.Fragment, null,
                variant === types_1.snackbarVariants.SUCCESS && (react_1.default.createElement(CheckCircleIcon_1.default, { className: classes.checkCircleIcon })),
                message), className: classes.content + " " + colorClass + " " + classes.before, classes: { message: classes.message }, action: [
                react_1.default.createElement(IconButton_1.default, { key: "close", "aria-label": "Close", color: "inherit", onClick: function () { return dispatch(actions_1.default.closeSnackbar()); }, className: classes.closeButton, size: "small" },
                    react_1.default.createElement("div", { className: classes.iconWrapper },
                        react_1.default.createElement(CloseIcon_1.default, { color: variant === types_1.snackbarVariants.INFO
                                ? '#fff'
                                : theme.palette.text.primary, size: 16 }))),
            ] })));
};
exports.default = MessageSnackbar;
